import { breakpoints } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const BufferImage = styled.img`
  position: absolute;
  opacity: 0;
  z-index: -1;
`;

export const MainImg = styled.img`
  display: none;
  height: auto;

  @media (min-width: ${breakpoints.sm}) {
    display: block;
    max-width: 100%;
    max-height: 100%;

    cursor: zoom-in;
    flex-grow: 0;
    transition: opacity 0.5s;
  }
`;

export const fullHeightMainImgClass = css`
  height: 100%;

  max-height: unset !important;
  max-width: unset !important;

  aspect-ratio: unset;

  @media (min-width: ${breakpoints.xl}) {
    height: calc(100% - 3rem); // 1.5rem padding on top and bottom
    width: unset;
  }
`;
export const notFullHeightMainImgClass = css`
  max-height: min(85%, 21.875rem) !important;

  @media (min-width: 1280px) {
    max-height: min(85%, 25rem) !important;
  }
  @media (min-width: 1680px) {
    max-height: min(85%, 28.125rem) !important;
  }
`;
